// OLD: imports were only used by the notification + immediate-logout flow below
// import store from '@/store';
// import { showNotification } from '@/plugins/notification';

// NEW: 401/403 show ONE blocking SessionExpiredModal with a "Log In" button
// (which dispatches logOut → /sign-in) instead of a notification per failed
// call + immediate logout — see services/error/sessionExpired.js
import { triggerSessionExpired } from './sessionExpired.js';

export async function authErrorHandler(response) {
  let error = response?.status || response?.statuscCode;

  // OLD: fired a notification and logOut for EVERY failing call — when the
  // session died, parallel requests spammed duplicate notifications.
  // if (error === 401) {
  //   showNotification('error', `Error ${error}`, 'Session expired. Please log in to continue.', 5000);
  //   store.dispatch('logOut', error);
  // }
  // if (error === 403 && response.code === 403021) {
  //   showNotification(
  //     'error',
  //     `Error ${error}`,
  //     'This account no longer exists. Contact support for help, or log out to return to the home screen.',
  //     5000,
  //   );
  //   store.dispatch('logOut', error);
  // }

  // NEW: trip the session-expired popup once; repeat failures are silent
  if (error === 401 || error === 403) {
    // Backend code 403021 = account deleted — show a more specific message
    const accountGone = error === 403 && response.code === 403021;
    triggerSessionExpired(
      accountGone
        ? 'This account no longer exists. Contact support for help, or log in with a different account.'
        : undefined,
    );
  }
}
